
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      isSticky: false,
    };
  },
  computed: {
    hasChannelAccess() {
      return this.$store.state.piano.access.channelAccess;
    },
    hasChannelTrialAccess() {
      return this.$store.state.piano.access.channelTrialAccess;
    },
  },
  methods: {
    handleSticky() {
      const menuTop: Element | null = document.querySelector('.header-primary .header .header-menu--top');
      const menuBottom: Element | null = document.querySelector('.header-bottom');

      const menuTopHeight: number = menuTop?.getBoundingClientRect().height || 0;
      const menuBottomHeight: number = menuBottom?.clientHeight || 0;

      if (window) {
        const scroll: number = window.pageYOffset;
        this.isSticky = scroll >= menuTopHeight + menuBottomHeight;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      // Disable sticky in Internet Explorer
      if (this.$ua.browser() !== 'Internet Explorer') {
        this.handleSticky();
        window.addEventListener('scroll', this.handleSticky);
        window.addEventListener('resize', this.handleSticky);
      }
    });
  },
});
